import { updateFilter } from '!/actions/creators';
import { Fragment } from 'react';
import { connect } from 'react-redux';
import ClearAll from '../ClearAll/ClearAll';
import AppliedFilterItem from './AppliedFilterItem/AppliedFilterItem';

const actions = { updateFilter };

const AppliedFilters = props => {
  let { applied, values, updateFilter } = props;

  const removeFilter = (name, value) => {
    const appliedFilters = [...values[name]];
    [].concat(value || []).forEach(v => appliedFilters.splice(appliedFilters.indexOf(v), 1));
    updateFilter(name, appliedFilters);
  };

  return (
    <Fragment>
      {applied.length > 0 && (
        <ul className="search-layout__applied-filters">
          {applied.map(
            (attribute, index) =>
                (attribute === 'price_range' || attribute === 'averageRating') ? (
                <AppliedFilterItem
                  attribute={attribute}
                  name={[...values[attribute]]}
                  onClick={removeFilter}
                  key={index}
                />
              ) : (
                values[attribute].map((value, index) => (
                  <AppliedFilterItem attribute={attribute} name={value} onClick={removeFilter} key={index} />
                ))
              )
          )}
          {(applied.length > 1) &&
            <li>
              <ClearAll />
            </li> 
          }
        </ul>
      )}
    </Fragment>
  );
};

function mapStateToProps({ applied, values }) {
  return { applied, values };
}

export default connect(
  mapStateToProps,
  actions
)(AppliedFilters);
